import type { Disposable } from '@patsnap/tahiti-core';
import type { OnboardingBrowserRuntime } from '../services/onboarding-browser-runtime';

/**
 * 在捕获阶段监听高亮区域内的原生指针与点击交互。
 *
 * 捕获阶段可以确保子元素即使停止冒泡，也会先结束 onboarding 视觉，
 * 同时不会阻止按钮、下拉框或输入框继续执行原有业务行为。
 */
export function listenForActiveRegionInteraction(
    runtime: OnboardingBrowserRuntime,
    element: Element,
    listener: EventListener,
): Disposable {
    let isDisposed = false;
    runtime.addEventListener(element, 'pointerdown', listener, true);
    runtime.addEventListener(element, 'click', listener, true);

    return {
        dispose: () => {
            if (isDisposed) return;
            isDisposed = true;
            runtime.removeEventListener(element, 'pointerdown', listener, true);
            runtime.removeEventListener(element, 'click', listener, true);
        },
    };
}

/** 判断当前交互是否来自目标选择器本身或其后代元素。 */
export function isInteractionTargetWithin(event: Event, selector: string): boolean {
    return event.target instanceof Element && event.target.closest(selector) !== null;
}
